import Settings from "../Svg/Settings";
import Database from "../../common/Svg/Database";
import Apps from "../Svg/Apps";
import Tree from "../../common/Svg/Tree";
import Logout from "../Svg/Logout";

export const menuConfig: any = [
  {
    id: "customerGroupsMenu",
    permissionKey: "DeviceDetails",
    canReadKey: "canRead",
    tooltip: "Customer & groups",
    icon: <Tree />,
    navigateTo: "/",
    toggleDrawer: true,
    position: "top",
  },
  {
    id: "modbusClient",
    permissionKey: "ModbusClient",
    canReadKey: "canRead",
    tooltip: "Configuration Manager",
    icon: <Settings />,
    navigateTo: "/modbus-client",
    toggleDrawer: false,
    position: "top",
  },
  {
    id: "dataBackfill",
    permissionKey: "DataBackFill",
    canReadKey: "canRead",
    tooltip: "Data Backfill",
    icon: <Database />,
    navigateTo: "/data-backfill",
    toggleDrawer: false,
    position: "top",
  },
  {
    id: "apps",
    permissionKey: null, // No permission required
    tooltip: "Account Management",
    icon: <Apps />,
    navigateTo: "/account-management",
    toggleDrawer: false,
    position: "bottom",
  },
  {
    id: "logout",
    permissionKey: null, // No permission required
    tooltip: "Logout",
    icon: <Logout />,
    navigateTo: null, // No navigation required
    toggleDrawer: false,
    position: "bottom",
    action: "logout", // Custom action for logout
  },
];
